import { InjectionToken } from '@angular/core';
import { MaintenanceConfig } from './models/maintenance-config.model';

export const MAINT_CONFIG: InjectionToken<MaintenanceConfig> = new InjectionToken('MaintenanceConfig');
